import { FeedbackStep } from './store/enums'
import { useFeedbackStore } from './store'

interface FeedbackStepQueryReturn {
  handleBack: () => void
  handleNext: () => void
}

export const useFeedbackStepQuery = (): FeedbackStepQueryReturn => {
  const route = useRoute()
  const router = useRouter()
  const feedbackStore = useFeedbackStore()

  const navigateToStep = (step: FeedbackStep): void => {
    router.replace({ query: { ...route.query, step } })
  }

  const handleBack = (): void => {
    const currentIndex = feedbackStore.getStepOrder.indexOf(feedbackStore.step)
    const prevIndex = currentIndex - 1

    if (prevIndex >= 0) {
      navigateToStep(feedbackStore.getStepOrder[prevIndex]!)
    }
  }

  const handleNext = (): void => {
    const currentIndex = feedbackStore.getStepOrder.indexOf(feedbackStore.step)
    const nextIndex = currentIndex + 1

    if (nextIndex < feedbackStore.getStepOrder.length) {
      navigateToStep(feedbackStore.getStepOrder[nextIndex]!)
    }
  }

  return {
    handleBack,
    handleNext,
  }
}
